module.exports = __webpack_public_path__ + "img/image10.98938e9.webp";